/**
 * NZ date helpers (DD/MM/YYYY).
 *
 * Stored clinical dates (DOB, injury date) are kept as DD/MM/YYYY strings.
 * `new Date("06/07/1980")` parses that as US MM/DD (7 June), so formatting it
 * back through toLocaleDateString silently swaps day and month — the cause of
 * the "box shows MM/DD" bug on the clinical letter. We therefore parse
 * day-first strings with an explicit regex and only fall back to `new Date()`
 * for ISO strings / Date objects (e.g. appointment slots, generatedAt).
 *
 * Mirrors backend/utils/letterPdfGenerator.js `formatDateNZ`.
 */
export function formatNZDate(value) {
  if (!value) return '';
  const s = String(value).trim();
  const dmy = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
  if (dmy) {
    let [, d, m, y] = dmy;
    if (y.length === 2) y = '20' + y;
    return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
  }
  const dt = new Date(s);
  if (isNaN(dt.getTime())) return s;
  return dt.toLocaleDateString('en-NZ', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

/**
 * Normalise a date value to YYYY-MM-DD for comparison, day-first aware.
 * Returns the trimmed original if it can't be parsed.
 */
export function normalizeNZDateISO(value) {
  if (!value) return '';
  const s = String(value).trim();
  const dmy = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
  if (dmy) {
    let [, d, m, y] = dmy;
    if (y.length === 2) y = '20' + y;
    return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
  }
  const dt = new Date(s);
  return isNaN(dt.getTime()) ? s : dt.toISOString().slice(0, 10);
}
